var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"interval-selector"},_vm._l((_vm.intervals),function([name, length],index){return _c('div',{staticClass:"interval-selector__item",class:{ 'interval-selector__item--active': name == _vm.currentInterval.name },on:{"click":function($event){return _vm.changeIntervalIndex(index)}}},[_vm._v("\n    "+_vm._s(name)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }